import {createStyles} from '@material-ui/core';
import type {Theme} from '@material-ui/core/styles';

export default createStyles((theme: Theme) => ({
    color: {
        display: 'flex',
        alignItems: 'center',
        '& div:first-of-type': {
            width: theme.spacing(12),
            height: theme.spacing(12),
            marginRight: theme.spacing(2),
            borderRadius: theme.shape.borderRadius,
        },
        marginBottom: theme.spacing(6),
    },
}));
